import React, { useMemo } from 'react';
import { Paper, Box, Typography, IconButton } from '@mui/material';
import { EmployeesSummary } from '../../models/reports';
import { ColorPalette } from '../../styles/constants';
import { ReportsEmployeeWorktime } from './reportsWorktimeDisplay';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { ROLES_ID } from '../../models/employee';
import { generateUserWithIdLabel } from '../../services/employeeService';

interface ReportsListEmployeeItemMobileProps {
  employeeSummary: EmployeesSummary;
  projectFilter: string | null;
  setSelectedEmployee: (employeeSummary: EmployeesSummary) => void;
}

const styles = {
  paper: {
    p: 0.5,
    marginBottom: 2,
    borderRadius: '5px',
    width: '100%',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
  },
  contentBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '48px',
    padding: '0 16px',
  },
  workedTime: {
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    color: ColorPalette.DARK_GRAY,
    mr: 2,
  },
  workedTimeWarning: {
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    color: ColorPalette.WARNING_RED,
    mr: 2,
  },
  workedTimeFulfilled: {
    display: 'inline-flex',
    alignItems: 'center',
    mr: 2,
  },
  peopleMarker: {
    color: ColorPalette.DARK_GRAY,
    marginLeft: '14px',
  },
};

export function ReportsEmployeeItemMobile({
  employeeSummary,
  projectFilter,
  setSelectedEmployee,
}: ReportsListEmployeeItemMobileProps): JSX.Element {
  const { employee, loggedHours, workingHours } = employeeSummary;

  const isTeamLead = useMemo(() => {
    return employeeSummary.employee.permissionGroups.some(
      (group) => group.id === ROLES_ID.TEAM_LEAD
    );
  }, [employeeSummary]);

  return (
    <Paper
      sx={styles.paper}
      onClick={() => setSelectedEmployee(employeeSummary)}
    >
      <Box sx={styles.contentBox}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography>
            {generateUserWithIdLabel(employee.name, employee.internalId)}
          </Typography>
          {isTeamLead && (
            <IconButton>
              <PeopleAltIcon sx={styles.peopleMarker} />
            </IconButton>
          )}
        </Box>

        <Box>
          <ReportsEmployeeWorktime
            loggedHours={loggedHours}
            workingHours={workingHours}
            projectFilter={projectFilter}
          />
        </Box>
      </Box>
    </Paper>
  );
}
